//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryKsCjfh,
  queryKsCjxList,
} from '@/https/otherApplication'
import {
  Span,
  Textarea,
} from '@/constant/componentConfig'
import CForm from '@/components/CForm'

export default {
  components: { CForm },

  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      studyInfo: {},
      markList: [],
    }
  },

  computed: {
    renderData () {
      return [
        new Span({
          label: '姓名',
          value: 'xm',
          name: 'xm',
        }),
        new Span({
          value: 'ksh',
          name: 'xm',
          label: '考生号',
        }),
        new Span({
          value: 'zjhm',
          name: 'zjhm',
          label: '证件号码',
        }),
        new Span({
          label: '成绩项目',
          value: 'cjxmc',
          name: 'cjxmc',
        }),
        new Textarea({
          value: 'sqly',
          required: false,
          readOnly: true,
          label: '申请理由',
        }),
      ]
    },
  },

  watch: {},

  async created () {
    await this.queryMarks()
    await this.queryBaseInfo()
  },

  methods: {
    async queryBaseInfo () {
      const { data } = await queryKsCjfh({
        pcdm: this.$route.query.pcdm,
        wid: this.$route.query.wid,
      })

      const list = data.cjxdm ? data.cjxdm.split(',') : []
      this.studyInfo = {
        ...(data || {}),
        cjxdm: data.cjxdm ? data.cjxdm.split(',') : [],
        cjxmc: list
          .map((dm) => {
            return this.markList.find((item) => item.key === dm)?.value
          })
          .join('、'),
      }
    },

    async queryMarks () {
      const { data } = await queryKsCjxList({
        pcdm: this.$route.query.pcdm,
        wid: this.$route.query.wid,
      })

      this.markList = data || []
    },

    goBack () {
      this.$router.go(-1)
    },
  },
}
